import { Routes, Route } from 'react-router-dom';
import { TournamentProvider } from '../mobile/TournamentContext';
import { AppPrefixProvider } from '../mobile/AppPrefixContext';
import { useAnalyticsTracker } from '../hooks/useAnalyticsTracker';
import { useGoogleAnalytics } from '../hooks/useGoogleAnalytics';
import TabletSidebar from './TabletSidebar';

import MobileHome from '../mobile/pages/MobileHome';
import MobileSchedule from '../mobile/pages/MobileSchedule';
import MobileLeaderboard from '../mobile/pages/MobileLeaderboard';
import MobileAbout from '../mobile/pages/MobileAbout';
import MobileRegistration from '../mobile/pages/MobileRegistration';
import MobileHistory from '../mobile/pages/MobileHistory';
import MobileSponsors from '../mobile/pages/MobileSponsors';
import MobilePrizeBreakdown from '../mobile/pages/MobilePrizeBreakdown';
import MobilePress from '../mobile/pages/MobilePress';
import MobileEventCalendar from '../mobile/pages/MobileEventCalendar';
import MobilePrivacyPolicy from '../mobile/pages/MobilePrivacyPolicy';
import MobileTerms from '../mobile/pages/MobileTerms';
import MobileDashboard from '../mobile/pages/MobileDashboard';
import MobileAdminPlayers from '../mobile/pages/admin/MobileAdminPlayers';
import MobileAdminPartners from '../mobile/pages/admin/MobileAdminPartners';
import MobileAdminEvents from '../mobile/pages/admin/MobileAdminEvents';
import MobileAdminFinance from '../mobile/pages/admin/MobileAdminFinance';
import MobileAdminAnalytics from '../mobile/pages/admin/MobileAdminAnalytics';
import MobileAdminSettings from '../mobile/pages/admin/MobileAdminSettings';
import MobileAdminTournaments from '../mobile/pages/admin/MobileAdminTournaments';
import MobileAdminPress from '../mobile/pages/admin/MobileAdminPress';
import MobileAdminContent from '../mobile/pages/admin/MobileAdminContent';
import MobileAdminCalendar from '../mobile/pages/admin/MobileAdminCalendar';
import MobileAdminCourses from '../mobile/pages/admin/MobileAdminCourses';
import MobileAdminScores from '../mobile/pages/admin/MobileAdminScores';
import MobileAdminMessaging from '../mobile/pages/admin/MobileAdminMessaging';
import MobileInvite from '../mobile/pages/MobileInvite';
import MobilePromo from '../mobile/pages/MobilePromo';
import AdminAuthGate from '../components/AdminAuthGate';
import { ScorerAuthGate } from '../mobile/ScorerApp';
import ScorerHome from '../mobile/pages/scorer/ScorerHome';
import ScorerGroupsPage from '../mobile/pages/scorer/ScorerGroupsPage';
import ScorerGroupScoreEntry from '../mobile/pages/scorer/ScorerGroupScoreEntry';

export default function TabletApp() {
  useGoogleAnalytics();
  useAnalyticsTracker();

  return (
    <AppPrefixProvider prefix="/t">
    <TournamentProvider>
      <div className="min-h-screen bg-gray-50 font-body flex">
        <TabletSidebar />

        <main className="ml-56 flex-1 min-w-0">
          <Routes>
            <Route index element={<MobileHome />} />
            <Route path="schedule" element={<MobileSchedule />} />
            <Route path="calendar" element={<MobileEventCalendar />} />
            <Route path="leaderboard" element={<MobileLeaderboard />} />
            <Route path="about" element={<MobileAbout />} />
            <Route path="registration" element={<MobileRegistration />} />
            <Route path="history" element={<MobileHistory />} />
            <Route path="sponsors" element={<MobileSponsors />} />
            <Route path="prize-breakdown" element={<MobilePrizeBreakdown />} />
            <Route path="press" element={<MobilePress />} />
            <Route path="privacy-policy" element={<MobilePrivacyPolicy />} />
            <Route path="terms" element={<MobileTerms />} />
            <Route path="admin" element={<MobileDashboard />} />
            <Route path="admin/players" element={<AdminAuthGate requiredTab="players" redirectTo="/t/admin"><MobileAdminPlayers /></AdminAuthGate>} />
            <Route path="admin/partners" element={<AdminAuthGate requiredTab="partners" redirectTo="/t/admin"><MobileAdminPartners /></AdminAuthGate>} />
            <Route path="admin/events" element={<AdminAuthGate requiredTab="calendar" redirectTo="/t/admin"><MobileAdminEvents /></AdminAuthGate>} />
            <Route path="admin/finance" element={<AdminAuthGate requiredTab="finance" redirectTo="/t/admin"><MobileAdminFinance /></AdminAuthGate>} />
            <Route path="admin/analytics" element={<AdminAuthGate requiredTab="analytics" redirectTo="/t/admin"><MobileAdminAnalytics /></AdminAuthGate>} />
            <Route path="admin/settings" element={<AdminAuthGate requiredTab="settings" redirectTo="/t/admin"><MobileAdminSettings /></AdminAuthGate>} />
            <Route path="admin/tournaments" element={<AdminAuthGate requiredTab="tournaments" redirectTo="/t/admin"><MobileAdminTournaments /></AdminAuthGate>} />
            <Route path="admin/press" element={<AdminAuthGate requiredTab="press" redirectTo="/t/admin"><MobileAdminPress /></AdminAuthGate>} />
            <Route path="admin/content" element={<AdminAuthGate requiredTab="contents" redirectTo="/t/admin"><MobileAdminContent /></AdminAuthGate>} />
            <Route path="admin/calendar" element={<AdminAuthGate requiredTab="calendar" redirectTo="/t/admin"><MobileAdminCalendar /></AdminAuthGate>} />
            <Route path="admin/courses" element={<AdminAuthGate requiredTab="courses" redirectTo="/t/admin"><MobileAdminCourses /></AdminAuthGate>} />
            <Route path="admin/scores" element={<AdminAuthGate requiredTab="scores" redirectTo="/t/admin"><MobileAdminScores /></AdminAuthGate>} />
            <Route path="admin/messaging" element={<AdminAuthGate requiredTab="messaging" redirectTo="/t/admin"><MobileAdminMessaging /></AdminAuthGate>} />
            <Route path="invite" element={<MobileInvite />} />
            <Route path="promo" element={<MobilePromo />} />
            <Route path="scorer" element={<ScorerAuthGate><ScorerHome /></ScorerAuthGate>} />
            <Route path="scorer/groups" element={<ScorerAuthGate><ScorerGroupsPage /></ScorerAuthGate>} />
            <Route path="scorer/group/:groupNumber" element={<ScorerAuthGate><ScorerGroupScoreEntry /></ScorerAuthGate>} />
          </Routes>
        </main>
      </div>
    </TournamentProvider>
    </AppPrefixProvider>
  );
}
